import { Text } from '@mnd-frontend/ui/publish/components';
import { useReportTranslation } from '../../../../hooks';

export const About = () => {
  const { Trans, t } = useReportTranslation();
  return (
    <Trans
      t={t}
      i18nKey={'reports_help_about_text'}
      components={{
        h3: (
          <Text
            as="h3"
            variant="reportHeadlineSmall"
            color="GREY_900"
            marginTop="SPACING_4"
            marginBottom="SPACING_2"
          >
            _
          </Text>
        ),
        p: (
          <Text as="p" variant="body" color="GREY_800">
            _
          </Text>
        ),
      }}
    />
  );
};
